import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'base64Decode'
})
export class Base64DecodePipe implements PipeTransform {

  transform(value: any): string {
    let decodeValue = 'The string to be decoded is not correctly encoded.';
    try {
      decodeValue = atob(value);
    } catch (e) {
     // console.log(e);
    }
    return decodeValue;
  }
}
